import gql from "graphql-tag";

const DocumentType = gql`
  fragment DocumentType on DocumentType {
    id
    name
  }
`;

const Document = gql`
  fragment Document on Document {
    id
    filename
    filetype
    createdAt
    updatedAt
    type {
      ...DocumentType
    }
  }
`;

export const GET_DOCUMENTS = gql`
  query GetDocuments {
    documents {
      ...Document
    }
  }
  ${DocumentType}
  ${Document}
`;

export const UPLOAD_DOCUMENT = gql`
  mutation UploadDocument($file: Upload!, $typeID: ID!) {
    uploadDocument(document: { typeID: $typeID, file: $file }) {
      ...Document
    }
  }
  ${DocumentType}
  ${Document}
`;

export const GET_DOCUMENT_TYPES = gql`
  query GetDocumentTypes {
    documentTypes {
      ...DocumentType
    }
  }
  ${DocumentType}
`;
